
import { mapOrderSumKeysToFreightLineKey } from '../details/freightLineSumKeys';

export default {

	freightLineSums(state) {

		let calculateSum = freightLineKey => state.order.freightLines.reduce(
			(accumulator, freightLine) =>
				isNaN(freightLine[freightLineKey]) ? accumulator : accumulator + freightLine[freightLineKey],
			0
		);

		let sums = {};

		for ( let orderSumKey in mapOrderSumKeysToFreightLineKey ) {

			sums[orderSumKey] = calculateSum(mapOrderSumKeysToFreightLineKey[orderSumKey]);
		}

		return sums;
	},
	getEventBySubOrderIdAndType(state) {
		return (subOrderId, eventType) => {
			let eventCandidates = state.order.events.filter(x => x.subOrderId === subOrderId);
			if (eventType === 'arrival') {
				return eventCandidates.find(event => event.type === 'delivered' || event.type === 'unloaded');
			}
			if (eventType === 'departure') {
				return eventCandidates.find(event => event.type === 'collected' || event.type === 'loaded');
			}

			return eventCandidates.find(event => event.type === eventType);
		};
	},
	getCollectEvent(state) {
		return state.order.events.find(x => x.type === 'collected');
	},
	getDeliveredEvent(state) {
		return state.order.events.find(x => x.type === 'delivered');
	},
	isFirstSubOrder() {
		return (subOrder) => subOrder.prev.length === 0;
	},
	isLastSubOrder() {
		return (subOrder) => subOrder.next.length === 0;
	},
	subOrderTabs(state) {
		return state.subOrders.map(
			(subOrder, index) => ({
				id: subOrder.id,
				index: index,
				tripNumber: subOrder.tripNumber,
				external: subOrder.external,
				name: `${ subOrder.despatchParty.name } - ${ subOrder.deliveryParty.name }`,
				prev: subOrder.prev ? subOrder.prev.length : 0,
				next: subOrder.next ? subOrder.next.length : 0,
			})
		);
	},
	orderIsLocked(state) {
		return state.order.invoiceNumber !== undefined && state.order.invoiceNumber !== null;
	},
	orderTypeHasTrip(state) {
		return state.order.orderType && state.orderTypes && Boolean(state.orderTypes.find(x => x.typeId === state.order.orderType.typeId && x.tripHandling));
	}

};
